import React from 'react';
import { Card, CardContent, Typography, Button } from '@material-ui/core';

const ExamSummaryCard = ({ examData, examCode, submissions, exportToExcel }) => (
  <Card style={{ marginBottom: 16 }}>
    <CardContent>
      <Typography variant="h6">{examData.title || examData.examTitle}</Typography>
      <Typography color="textSecondary">Assessment Code: {examCode}</Typography>
      <Typography color="textSecondary">
        Type: {examData.isDynamic ? 'Dynamic Assessment' : 'Legacy Assessment'}
      </Typography>
      {submissions.length > 0 && (
        <Button
          variant="contained"
          color="secondary"
          onClick={exportToExcel}
          style={{ marginTop: 8 }}
        >
          Export Results to Excel
        </Button>
      )}
    </CardContent>
  </Card>
);

export default ExamSummaryCard; 